import { useGetLongQuestionnaireSummaryReportQuery } from '@report/graphql';
import { dayjs } from '@shared/utils';
import { useMemo } from 'react';

import {
  buildLongFormSections,
  type LongFormSection,
} from '../../containers/questionnaire-report-long-form-template/utils';
import { useIsQuestionnaireReportFilterApplied } from '../use-is-questionnaire-report-filter-applied';
import { useQuestionnaireReportSearchParams } from '../use-questionnaire-report-search-params';

export function useLongFormTemplateData(): {
  sections: LongFormSection[];
  loading: boolean;
} {
  const [{ examStartDate, examEndDate, examCenter, examCourse }] =
    useQuestionnaireReportSearchParams();
  const isFilterApplied = useIsQuestionnaireReportFilterApplied();

  const { data, loading } = useGetLongQuestionnaireSummaryReportQuery({
    variables: {
      input: {
        startedAt: (examStartDate ? dayjs(examStartDate).startOf('day').toDate() : null) as Date,
        endedAt: (examEndDate ? dayjs(examEndDate).endOf('day').toDate() : null) as Date,
        examCenterCodes: examCenter.includes('all') ? null : examCenter,
        examCourseCodes: examCourse.includes('all') ? null : examCourse,
      },
    },
    skip: !isFilterApplied,
  });

  const report = data?.reportGetLongQuestionnaireSummaryReport;
  // While the filter is applied the scaffold is always built (a placeholder
  // one during loading) so the table stays on screen for the skeleton state.
  // Before any filter is applied there is nothing to show.
  const sections = useMemo(
    () => (isFilterApplied ? buildLongFormSections(report) : []),
    [isFilterApplied, report],
  );

  return { sections, loading };
}
